var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f65fb77e\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./research-2.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader!./~/vue-markdown-loader/_cache/research-2.vue
// module id = 168
// module chunks = 0